<template>
  <div class="simple-keyboard"></div>
</template>

<script setup lang="ts">
import Keyboard, {KeyboardElement, SimpleKeyboard} from 'simple-keyboard';
import {onMounted} from 'vue';

// Models
const data = defineModel<string>({required: true});

// Emits
const emit = defineEmits<{
  (e: 'change', value: string): void,
}>();

// Constants
const BACKSPACE = '{bksp}';
const LAYOUT_DEFAULT = 'default';
const LAYOUT_SHIFT = 'shift';
const SHIFT = '{shift}';
const SPACE = '{space}';

// Variables
let keyboard: Keyboard | null = null;

// Hooks
onMounted(() => {
  keyboard = new Keyboard(
    'simple-keyboard',
    {
      layout: {
        default: [
          `\` 1 2 3 4 5 6 7 8 9 0 - = ${BACKSPACE}`,
          'q w e r t y u i o p [ ] \\',
          `a s d f g h j k l ; '`,
          `${SHIFT} z x c v b n m , . / ${SHIFT}`,
          `.com @ ${SPACE}`,
        ],
        shift: [
          `~ ! @ # $ % ^ & * ( ) _ + ${BACKSPACE}`,
          'Q W E R T Y U I O P { } |',
          `A S D F G H J K L : "`,
          `${SHIFT} Z X C V B N M < > ? ${SHIFT}`,
          `.com @ ${SPACE}`,
        ],
      },
      buttonTheme: [
        {
          class: 'hg-backspace',
          buttons: `${BACKSPACE}`,
        },
      ],
      onRender: (instance?: SimpleKeyboard) => {
        if (!instance) return;

        let buttons: ({ el: KeyboardElement, content: string })[] = [];
        
        buttons.push({
          el: instance.getButtonElement(BACKSPACE) as KeyboardElement,
          content: 'backspace',
        });
        
        buttons = buttons.concat(
          (instance.getButtonElement(SHIFT) as KeyboardElement[]).map(v => {
            return {
              el: v,
              content: 'keyboard_capslock',
            };
          }),
        );

        buttons.forEach(item => {
          const bkspSpan = (item.el.firstChild as HTMLSpanElement);
          if (bkspSpan) {
            bkspSpan.className = 'material-symbols-outlined';
            bkspSpan.innerText = item.content;
          }
        });
      },
      onChange: input => {
        data.value = input;
        emit('change', input);
      },
      onKeyPress(button: string) {
        if (button === SHIFT)
          this.handleShift();
      },
      handleShift() {
        let currentLayout = keyboard!.options.layoutName;
        let shiftToggle = currentLayout === LAYOUT_DEFAULT ? LAYOUT_SHIFT : LAYOUT_DEFAULT;

        keyboard!.setOptions({
          layoutName: shiftToggle,
        });
      },
    });

  keyboard.setInput(data.value);
});
</script>